export class TimeRange {
    startTime: number;
    endTime: number;

    constructor() {
        this.startTime = 0;
        this.endTime = 0;
    }
}
